/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocEditIcon16Light } from './DocEditIcon16Light';
import { DocEditIcon16Regular } from './DocEditIcon16Regular';
import { DocEditIcon16Solid } from './DocEditIcon16Solid';
import { DocEditIcon20Light } from './DocEditIcon20Light';
import { DocEditIcon20Regular } from './DocEditIcon20Regular';
import { DocEditIcon20Solid } from './DocEditIcon20Solid';
import { DocEditIcon24Regular } from './DocEditIcon24Regular';
import { DocEditIcon24Solid } from './DocEditIcon24Solid';
import { DocEditIcon32Regular } from './DocEditIcon32Regular';
import { DocEditIcon64Regular } from './DocEditIcon64Regular';
var sizes = {
    16: {
        light: DocEditIcon16Light,
        regular: DocEditIcon16Regular,
        solid: DocEditIcon16Solid,
    },
    20: {
        light: DocEditIcon20Light,
        regular: DocEditIcon20Regular,
        solid: DocEditIcon20Solid,
    },
    24: {
        regular: DocEditIcon24Regular,
        solid: DocEditIcon24Solid,
    },
    32: {
        regular: DocEditIcon32Regular,
    },
    64: {
        regular: DocEditIcon64Regular,
    },
};
export var DocEditIcon = forwardRef('DocEditIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
